import Error32PxFilledRedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Error32PxFilledRed";
import styles from "./PriceError.module.scss";

type Props = {
  errorHeading: string;
  errorBody: string;
};

export const PriceError = ({ errorHeading, errorBody }: Props) => {
  if (!errorHeading && !errorBody) {
    return null;
  }

  return (
    <div className={styles.PriceError} data-testid="m2m-price-error">
      <div data-testid="m2m-price-error-icon">
        <Error32PxFilledRedIcon />
      </div>
      <div
        className={styles.PriceError__errorText}
        data-testid="m2m-price-error-text"
      >
        {errorHeading && (
          <h2
            className={styles.PriceError__errorTitle}
            data-testid="m2m-price-error-title"
          >
            {errorHeading}
          </h2>
        )}
        {errorBody && (
          <div
            className={styles.PriceError__errorBody}
            data-testid="m2m-price-error-body"
          >
            <p
              className={styles.PriceError__errorBodyText}
              dangerouslySetInnerHTML={{
                __html: `${errorBody}`,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
